import { type JSX } from 'react';

import { EloIcon, Flex, Heading, Stack, Text } from '@plurall/elo-v3';

import type { EloIconType } from '@plurall/elo-v3';

type Props = {
  icon: EloIconType;
  heading: string;
  description: string;
};

export function SectionCardEmptyState({ icon, heading, description }: Props): JSX.Element {
  return (
    <Flex
      direction='column'
      align='center'
      justify='center'
      gap='gap.large'
      paddingInline='padding.large'
      paddingBlock='padding.2xlarge'
      borderRadius='border.radius.small'
      bg='background.secondary'>
      <Flex
        align='center'
        justify='center'
        padding='padding.medium'
        borderRadius='full'
        bg='background.disabled'>
        <EloIcon
          icon={icon}
          size='medium'
          color='foreground.tertiary'
        />
      </Flex>
      <Stack
        gap='gap.2xsmall'
        align='center'
        textAlign='center'>
        <Heading
          as='h3'
          textStyle='paragraph.medium.semibold'
          color='text.primary'>
          {heading}
        </Heading>
        <Text
          textStyle='paragraph.small.regular'
          color='text.tertiary'>
          {description}
        </Text>
      </Stack>
    </Flex>
  );
}
